import { TextField } from "@mui/material"
import { useFormContext } from "react-hook-form"
import { FormComponent, FormComponentType } from "./FormBuilder/types"

const MAX_LENGTH_MULTILINE_INPUT = 500
const MAX_LENGTH_INPUT = 500

type InputProps = {
  field: string
  component: FormComponent
  width?: string
  helperText?: string
}

export const Input = ({ field, component, width = "450px", helperText = "" }: InputProps) => {
  const { register } = useFormContext()
  const isTextArea = component.type === FormComponentType.Textarea

  return (
    <TextField
      required={!!component.required}
      disabled={!component.editable}
      multiline={isTextArea}
      rows={3}
      inputProps={{
        maxLength: isTextArea ? MAX_LENGTH_MULTILINE_INPUT : MAX_LENGTH_INPUT,
      }}
      type="text"
      variant="outlined"
      size="small"
      helperText={helperText}
      error={!!helperText}
      sx={{ width: `${width}` }}
      {...register(field)}
    />
  )
}
